import { merge } from "lodash.merge";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

import {
  initializeClientQuestionnaireFormCards,
  initializeClientQuestionnaireFormFieldsStates,
  initializeOutputReportDetails,
  initializeProposalCustomizations,
  initializeProposalSecurities,
  mapApiDataToClientQuestionnaireValues,
  updateClientQuestionnaireFormFieldsStates,
} from "../utils/helpers/clientQuestionnaire.helper";

const getInitialState = () => ({
  metadata: {
    isInitialized: false,
    questionnaireId: undefined,
    proposalId: undefined,
    reportId: undefined,
    sponsorName: undefined,
    groupName: undefined,
    createdByName: undefined,
    createdByEmail: undefined,
    status: undefined,
  },
  proposal: {},
  cardsStates: {},
  fieldsStates: {},
  modals: {},
});

export const useClientQuestionnaireFormStore = createWithEqualityFn(
  devtools(
    persist(
      (set, get) => ({
        data: getInitialState(),

        actions: {
          resetClientQuestionnaireFormStore: () => {
            set((s) => ({
              data: {
                ...getInitialState(),
              },
            }));
          },
          initializeClientQuestionnaireForm: ({
            pageMode,
            questionnaireId,
            genericReferenceData,
            fetchedClientQuestionnaireFormDetailsData = {},
            fetchedProposalDetails = {},
            fetchedOutputReportDetails = {},
          }) => {
            if (
              get().data.metadata.isInitialized ||
              (questionnaireId &&
                Object.keys(fetchedClientQuestionnaireFormDetailsData)
                  .length === 0)
            ) {
              return;
            }
            const proposal = fetchedProposalDetails;
            proposal.customizations = initializeProposalCustomizations(
              fetchedProposalDetails
            );
            proposal.securities = initializeProposalSecurities(
              fetchedProposalDetails
            );

            const report = initializeOutputReportDetails(
              fetchedOutputReportDetails
            );

            const cardsStates = initializeClientQuestionnaireFormCards({
              pageMode,
            });
            const defaultValues = mapApiDataToClientQuestionnaireValues({
              apiData: fetchedClientQuestionnaireFormDetailsData,
              pageMode,
              proposal,
              genericReferenceData,
            });
            const fieldsStates = initializeClientQuestionnaireFormFieldsStates({
              pageMode,
              genericReferenceData,
              proposal,
              report,
              defaultValues,
            });

            if (!fieldsStates.clientWithdrawals.isVisible) {
              cardsStates.AdditionalNotesCard.headerNumber = "4";
              cardsStates.SignAndCompleteCard.headerNumber = "5";
            }

            set((s) => ({
              data: {
                ...s.data,
                proposal,
                report,
                metadata: {
                  ...s.data.metadata,
                  isInitialized: true,
                },
                cardsStates,
                fieldsStates,
              },
            }));
          },
          updateClientQuestionnaireFormFieldsStates: ({
            newFormValues = {},
          }) => {
            if (Object.keys(newFormValues).length === 0) return;

            set((s) => ({
              data: {
                ...s.data,
                fieldsStates: {
                  ...updateClientQuestionnaireFormFieldsStates({
                    prevFieldsStates: s.data.fieldsStates,
                    newFormValues,
                  }),
                },
              },
            }));
          },
        },
      }),
      {
        name: "client-questionnaire-form",
        storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used,
        merge: (persistedState, currentState) =>
          merge(persistedState, currentState),
      }
    )
  )
);
